<template>
  <b-modal
    v-model="dataModal"
    centered
    no-close-on-backdrop
    no-close-on-esc
    title="Update Template"
    @close="onCloseModal">
    <div>
      <call-input
        v-model="$v.dataForm.name.$model"
        type-input="text"
        :valide="$v.dataForm.name.$error"
        float-name-label="Template Name" />
      <div
        :class="['call-select-modal__wrapper', 'call-input',
                 !dataForm.team_ids ? 'call-select--empty' : null]">
        <v-select
          v-model="dataForm.team_ids"
          multiple
          :options="computedDataSelectOptionsTeam"
          label="name"
          :components="{Deselect: dataComponentDeselect}"
          class="call-select-modal call-select call-select-multi">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>
        <label>Teams Avaliable For</label>
      </div>

      <div
        :class="['call-select-modal__wrapper', 'call-input',
                 !dataForm.project_ids ? 'call-select--empty' : null]">
        <v-select
          v-model="dataForm.project_ids"
          multiple
          :options="dataSelectOptionsProject"
          label="name"
          :components="{Deselect: dataComponentDeselect}"
          :disabled="!(dataForm.team_ids || []).length"
          class="call-select-modal call-select call-select-multi">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
          <template #selected-option-container="{ option, deselect }">
            <span
              class="vs__selected"
              :style="{'border-color': option.is_active ? '' : '#dd2f43 !important'}">
              {{ option.name }}
              <button
                type="button"
                class="vs__deselect"
                @click.stop="deselect(option)">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="xmark"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  class="svg-inline--fa fa-xmark fa-w-10"><path
                    fill="currentColor"
                    d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                    class="" /></svg>
              </button>
            </span>
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              <font-awesome-icon
                v-if="!option.is_active"
                class="tabel-icon--red"
                :icon="dataIconBan" />
              {{ option.name }}
            </div>
          </template>
        </v-select>
        <label>Projects Avaliable For</label>
      </div>
      <div
        :class="['call-select-modal__wrapper', 'call-input', $v.dataForm.body.$error && 'error-valide']">
        <b-form-textarea
          v-model="$v.dataForm.body.$model"
          placeholder="SMS template..."
          rows="3"
          max-rows="6" />
      </div>
    </div>
    <template #modal-footer>
      <call-button
        :icon="dataCloseIcon"
        type="danger"
        plain
        @click="onCloseModal()">
        Cancel
      </call-button>
      <call-button
        :icon="dataRefreshIcon"
        :disabled="$v.$invalid"
        type="success"
        @click="clickUpdateSmsTemplate()">
        Update Template
      </call-button>
    </template>
  </b-modal>
</template>

<script>
import { BFormTextarea, BModal } from 'bootstrap-vue';
import { faSearch, faSyncAlt, faBan } from '@fortawesome/pro-regular-svg-icons';
import CallButton from '../CallButton';
import CallInput from '../CallInput';
import { maxLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ID_ROLE_OPERATOR } from '../../../service/consts';
import { SMS_TEMPLATE_GET, SMS_TEMPLATE_UPDATE, TEAMS_GET_ALL, SMS_TEMPLATE_AVAILABLE_PROJECTS } from '../../../store/types/actions.types';
import iconsModal from '../../../mixins/iconsModal';
import selectAllTeams from '../../../mixins/select/selectAllTeams';

export default {
  name: 'CallModalUpdateSmsTemplate',
  components: {
    CallInput,
    CallButton,
    BModal,
    BFormTextarea
  },
  mixins: [validationMixin, iconsModal, selectAllTeams],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    templateId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dataModal: this.value,
      dataIconSearch: faSearch,
      dataIconRefresh: faSyncAlt,
      dataIconBan: faBan,
      dataShowPassword: false,
      availableProjects: [],
      dataForm: {
        name: null,
        team_ids: [],
        project_ids: [],
        body: null
      }
    };
  },
  validations: {
    dataForm: {
      name: {
        required
      },
      body: {
        required,
        maxLength: maxLength(255)
      }
    }
  },
  computed: {
    computedIsOperator () {
      return this.dataForm.role === ID_ROLE_OPERATOR;
    },

    computedDataSelectOptionsTeam () {
      const ids = this.dataForm.team_ids.map(({ id }) => id);
      return this.dataSelectOptionsTeam.filter(({ id }) => !ids.includes(id));
    },

    dataSelectOptionsProject () {
      const ids = this.dataForm.team_ids.map(({ id }) => id);
      const ids_p = this.dataForm.project_ids.map(({ id }) => id);

      const v = this.availableProjects
        .filter(item => ids.includes(item.id))
        .flatMap(item => item.projects)
        .sort((a, b) => Number(b.is_active) - Number(a.is_active))
        .filter(item => !ids_p.includes(item.id));
      return v;
    }
  },
  watch: {
    dataModal: {
      async handler (v) {
        try {
          const { payload } = await this.$store.dispatch(`sms/${SMS_TEMPLATE_AVAILABLE_PROJECTS}`);
          this.availableProjects = payload;
        } catch (e) {
          throw Error(e);
        }
      }
    },

    'dataForm.team_ids': {
      async handler (tid) {
        const arrTeamId = tid.map(({ id }) => id);
        const allIdProjectForTeam = this.availableProjects
          .filter(item => arrTeamId.includes(item.id))
          .flatMap(item => item.projects)
          .map(({ id }) => id);

        this.dataForm.project_ids = this.dataForm.project_ids.filter(({ id }) => allIdProjectForTeam.includes(id));
      }
    },

    async value () {
      this.dataModal = this.value;
      if (this.dataModal) {
        Object.assign(this.$data, this.$options.data.apply(this));
        this.$v.$reset();

        const [{ payload: { list = [] } }, { template }] = await Promise.all([
          await this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
            params: {
              short: true
            }
          }),
          this.$store.dispatch(`sms/${SMS_TEMPLATE_GET}`, {
            id: this.templateId
          })
        ]);
        this.dataSelectOptionsTeam = list;
        this.$set(this.dataForm, 'name', template?.name);
        this.$set(this.dataForm, 'body', template?.body);
        this.$set(this.dataForm, 'team_ids', (template?.teams || []).map(item => {
          return {
            id: item.id,
            name: item.name
          };
        })
        );
        this.$set(
          this.dataForm,
          'project_ids',
          (template?.team_projects || [])
            .flatMap(item => item.projects)
        );
      }
    }
  },
  methods: {
    onCloseModal () {
      this.$emit('input', false);
    },
    async clickUpdateSmsTemplate () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      try {
        await this.$store.dispatch(`sms/${SMS_TEMPLATE_UPDATE}`, {
          templateId: this.templateId,
          params: {
            ...this.dataForm,
            team_ids: this.dataForm.team_ids.map(item => item.id),
            project_ids: this.dataForm.project_ids.map(item => item.id)
          },
          context: this
        });
        this.$emit('on-update');
        this.$Notify({
          title: 'Sms Template',
          message: 'Successfully updated',
          type: 'success'
        });
        this.onCloseModal();
      } catch (e) {
        throw Error(e);
      }
    }
  }
};
</script>
